import React from "react";
import { Modal, Tab, Tabs, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setPersonType } from "@parts/person/actions";
import { setLoading } from '@inspinia-react/actions'

import Person from "@parts/person";
import PersonAdaptToCompany from "@parts/person/personAdaptToCompany";
import IndividualOrCopanySelect from "@parts/person/individualOrCopanySelect";
import Address from "@parts/address-component";
import UploadDigitalCertificate from '../../fiscal/digital-certificate/upload-certificate'

import {
  personValidate,
  addressValidate,
  valideteDocument,
  validateCompany
} from "@parts/person/utils";

import { api, getBranchOwner, getUser, post, put } from "@config";
import { notification } from "antd";

const branch = getBranchOwner()
const user = getUser()

if (branch && user && user.access_type === 2) {
  branch.id = user.salesperson.branch_owner
}

class ModalCreateClient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      errors: [],
      hasErrors: [],

      file: null,
      pwd: ""
    };
    this._save = this._save.bind(this);
    this._cancel = this._cancel.bind(this);
  }
  _save() {
    const {
      type,
      doc,
      fancyName: fancy_name,
      stateRegistry: state_registry,
      crt
    } = this.props;
    const personErrors = personValidate(this.props);
    const docErrors = valideteDocument(this.props);
    const valideAddress = addressValidate(this.props, false);

    this.setState({ ...this, errors: [] })

    if (docErrors.length) {
      this.setState({ ...this, errors: docErrors })
      return;
    }
    if (personErrors.errors.length > 0) {
      this.setState({ ...this, errors: personErrors.errors })
      return;
    }

    if (type != 0) {
      const companyErrors = validateCompany(this.props)
      if (companyErrors.length) {
        this.setState({ ...this, errors: companyErrors })
        return;
      }
    }

    if (valideAddress.errors.length > 0) {
      this.showErros(valideAddress.errors);
      return;
    }

    let certErrors = []


    if (this.state.file == null) {
      certErrors.push("Certificado inválido")
    }

    if (this.state.pwd == "") {
      certErrors.push("Senha inválida")
    }
    if (certErrors.length) { 
      this.setState({ ...this, errors: certErrors })
      return;
    }

    const data = {
      ...personErrors.data,
      ...valideAddress,
    };
    if (type === 0) {
      data.individual = { cpf: doc };
    } else {
      data.company = {
        cnpj: doc,
        fancy_name,
        state_registry,
      };
    }

    if (this.props.createBranch) {
      data.branch = {
        crt: crt || 1,
        is_fiscal: true,
        main_company: false,
        aliquota_credito: 1,
        branch_type: type + 1
      }
      this.props.createBranch(data, { file: this.state.file, pwd: this.state.pwd })
      return
    }

    this.props.setLoading(true);

    const payload = (client) => {
      notification.open({
        type: "success",
        message: (
          <p>
            <strong>{client.name}</strong> cadastrado
          </p>
        ),
        description: `O cliente foi cadastrado com sucesso!`,
      });
      this.props.onAdd(client)
      if (this.props.onOpen) this.props.onOpen()
      this.setState({ ...this, show: false })
    };

    const errPayload = () => this.props.setLoading(false)

    const url = `${api.clients}?branch_owner=${branch.id}`;
    post(url, data, payload, errPayload);

  }
  _cancel() {
    if (this.props.onOpen) this.props.onOpen()
    this.setState({ ...this, show: false })
  }

  UNSAFE_componentWillMount() {
    this.props.setPersonType(0);
  }

  onOpen() {
    if (this.props.onOpen) this.props.onOpen()
    this.setState({ ...this, show: true })
  }

  render() {
    const { show } = this.state;
    const { type } = this.props;
    return (
      <div>
        {this.props.icon ?
          <Button className='fas fa-plus' onClick={() => this.onOpen()} /> :
          <Button onClick={() => this.onOpen()}
          >
            Criar novo
            </Button>
        }
        <Modal show={show} size="lg">
          <Modal.Body>
            <h2 className="py-2">Cadastrar cliente</h2>
            <div className="text-danger">
              <ul>
                {this.state.errors.map(err => <li>{err}</li>)}
              </ul>
            </div>
            <IndividualOrCopanySelect mei={this.props.mei} />
            <Tabs defaultActiveKey="data" id="uncontrolled-tab-example">
              <Tab eventKey="data" title="Dados do cliente *">
                <div className="py-2">
                  <Person />
                </div>
              </Tab>
              {type === 0 ? (
                <div></div>
              ) : (
                  <Tab eventKey="companyData" title="Dados da Empresa *">
                    <div className="py-2">
                      <PersonAdaptToCompany mei={this.props.mei} crt={this.props.crt} />
                    </div>
                  </Tab>
                )}

              <Tab eventKey="address" title="Endereço *">
                <div className="py-2">
                  <Address />
                </div>
              </Tab>
              {this.props.hasCertificate ?
                <Tab eventKey="certifacate" title="Certificado *">
                  <div className="py-2">
                    <UploadDigitalCertificate
                      onUpload={(file) => this.setState({ file })}
                      onChangePassword={(pwd) => this.setState({ pwd })}
                    />
                  </div>
                </Tab> :
                <div />
              }
            </Tabs>
            <ul></ul>
          </Modal.Body>
          <Modal.Footer>
            <Button className="mx-3" variant='danger' onClick={this._cancel}>
              cancelar
            </Button>
            <Button className="mx-3" onClick={this._save}>
              salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  showErros(errors) {
    notification.close(811);
    let errorsMsg = [];
    errors.forEach((err) => {
      errorsMsg.push(
        <li className="list-group-item py-0 my-0 mb-1">{`${err}`}</li>
      );
    });
    notification.open({
      type: "error",
      message: "Ops..",
      description: <ul className="list-group">{errorsMsg}</ul>,
      key: 811,
    });
  }

}

const mapStateToProps = (state) => ({
  //person
  name: state.basePersonName,
  email: state.basePersonEmail,
  phone_number: state.basePersonPhone,

  //company
  fancyName: state.fancyName,
  stateRegistry: state.stateRegistry,
  crt: state.crt,

  //address
  cityLocation: state.cityLocation,
  complement: state.complement,
  district: state.district,
  postalCode: state.postalCode,
  stateLocation: state.stateLocation,
  streetNumber: state.streetNumber,
  street: state.street,
  type: state.personType,
  doc: state.personDoc,
});
const mapDisptachToProps = (dispatch) => bindActionCreators({
  setPersonType,
  setLoading
}, dispatch);

export default connect(mapStateToProps, mapDisptachToProps)(ModalCreateClient);



// WEBPACK FOOTER //
// ./src/components/pages/clients/create/modal-create.jsx